/* Mist House Explore — category switching, accessible carousels, swatches, safe add to bag */
(function () {
  'use strict';

  function initSection(root) {
    if (!root || root.dataset.mheReady === 'true') return;
    root.dataset.mheReady = 'true';

    const mobileQuery = window.matchMedia('(max-width: 989px)');
    const tabsArea = root.querySelector('[data-tabs]');
    const tabs = Array.from(root.querySelectorAll('[data-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-panel]'));
    const carouselPrev = root.querySelector('[data-carousel-prev]');
    const carouselNext = root.querySelector('[data-carousel-next]');
    const tabPrev = root.querySelector('[data-tab-prev]');
    const tabNext = root.querySelector('[data-tab-next]');
    const progress = root.querySelector('[data-progress]');
    const progressThumb = root.querySelector('[data-progress-thumb]');
    const dialog = root.querySelector('[data-variant-dialog]');
    const dialogFields = root.querySelector('[data-variant-fields]');
    const dialogError = root.querySelector('[data-variant-error]');
    const dialogTitle = root.querySelector('[data-dialog-title]');
    const confirmAdd = root.querySelector('[data-confirm-add]');
    const toast = root.querySelector('[data-toast]');
    let toastTimer;
    let activeId = tabs.length ? tabs[0].dataset.tab : null;
    let modalCard = null;
    let cartIds = new Set();
    let cartDebounce;

    const shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || root.dataset.root || '/';
    const basePath = shopRoot.endsWith('/') ? shopRoot : shopRoot + '/';
    const currency = root.dataset.currency || 'GBP';
    const locale = (root.dataset.locale || 'en-GB').replace('_', '-');
    let priceFormatter;
    try { priceFormatter = new Intl.NumberFormat(locale, { style: 'currency', currency: currency }); }
    catch (_) { priceFormatter = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }); }

    function money(cents) {
      return priceFormatter.format((Number(cents) || 0) / 100);
    }

    function activePanel() { return panels.find(panel => panel.dataset.panel === activeId) || null; }
    function viewport() { const panel = activePanel(); return panel && panel.querySelector('[data-viewport]'); }
    function hasOverflow(element) { return element && element.scrollWidth > element.clientWidth + 3; }

    function showToast(message) {
      if (!toast) return;
      toast.textContent = message;
      toast.classList.add('is-visible');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 2600);
    }

    function toggleCarouselNavigation() {
      const view = viewport();
      const canScroll = hasOverflow(view);
      const showArrows = mobileQuery.matches ? root.dataset.arrowsMobile === 'true' : root.dataset.arrowsDesktop === 'true';
      const showProgress = mobileQuery.matches ? root.dataset.progressMobile === 'true' : root.dataset.progressDesktop === 'true';

      if (carouselPrev) {
        carouselPrev.hidden = !showArrows || !canScroll;
        carouselPrev.disabled = !canScroll || view.scrollLeft <= 2;
      }
      if (carouselNext) {
        carouselNext.hidden = !showArrows || !canScroll;
        carouselNext.disabled = !canScroll || view.scrollLeft >= view.scrollWidth - view.clientWidth - 2;
      }
      if (progress) progress.hidden = !showProgress || !canScroll;
      if (progressThumb && canScroll) {
        const fraction = Math.min(1, view.clientWidth / view.scrollWidth);
        const thumbWidth = Math.max(12, fraction * 100);
        const maxScroll = view.scrollWidth - view.clientWidth;
        const fractionScrolled = maxScroll > 0 ? view.scrollLeft / maxScroll : 0;
        progressThumb.style.width = thumbWidth + '%';
        progressThumb.style.position = 'relative';
        progressThumb.style.transform = 'none';
        progressThumb.style.left = (Math.max(0, Math.min(1, fractionScrolled)) * (100 - thumbWidth)) + '%';
      }
    }

    function updateTabArrows() {
      if (!tabsArea) return;
      const canScroll = hasOverflow(tabsArea);
      if (tabPrev) {
        tabPrev.hidden = !canScroll;
        tabPrev.disabled = tabsArea.scrollLeft <= 1;
      }
      if (tabNext) {
        tabNext.hidden = !canScroll;
        tabNext.disabled = tabsArea.scrollLeft >= tabsArea.scrollWidth - tabsArea.clientWidth - 1;
      }
    }

    function selectCategory(id, focusTab) {
      if (!id || !tabs.find(tab => tab.dataset.tab === id)) return;
      activeId = id;
      tabs.forEach(tab => {
        const selected = tab.dataset.tab === id;
        tab.classList.toggle('is-active', selected);
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.tabIndex = selected ? 0 : -1;
        if (selected) {
          // Avoid scrolling the whole homepage when the section first initialises.
          if (focusTab) {
            tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
            tab.focus({ preventScroll: true });
          }
        }
      });
      panels.forEach(panel => {
        const selected = panel.dataset.panel === id;
        panel.hidden = !selected;
        if (selected) {
          const scroller = panel.querySelector('[data-viewport]');
          if (scroller) scroller.scrollLeft = 0;
        }
      });
      requestAnimationFrame(toggleCarouselNavigation);
    }

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => selectCategory(tab.dataset.tab, false));
      tab.addEventListener('keydown', e => {
        let newIndex;
        if (e.key === 'ArrowRight') newIndex = (index + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') newIndex = (index - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') newIndex = 0;
        else if (e.key === 'End') newIndex = tabs.length - 1;
        else return;
        e.preventDefault();
        selectCategory(tabs[newIndex].dataset.tab, true);
      });
    });

    function scrollProducts(direction) {
      const view = viewport();
      if (!view) return;
      const card = view.querySelector('[data-product-card]');
      const track = view.querySelector('[data-track]');
      const gap = track ? parseFloat(getComputedStyle(track).gap) || 0 : 0;
      const amount = card ? card.getBoundingClientRect().width + gap : view.clientWidth * .8;
      view.scrollBy({ left: amount * direction, behavior: 'smooth' });
    }

    if (carouselPrev) carouselPrev.addEventListener('click', () => scrollProducts(-1));
    if (carouselNext) carouselNext.addEventListener('click', () => scrollProducts(1));
    if (tabPrev && tabsArea) tabPrev.addEventListener('click', () => tabsArea.scrollBy({ left: -260, behavior: 'smooth' }));
    if (tabNext && tabsArea) tabNext.addEventListener('click', () => tabsArea.scrollBy({ left: 260, behavior: 'smooth' }));
    if (tabsArea) tabsArea.addEventListener('scroll', updateTabArrows, { passive: true });

    panels.forEach(panel => {
      const scroller = panel.querySelector('[data-viewport]');
      if (scroller) scroller.addEventListener('scroll', () => {
        if (!panel.hidden) toggleCarouselNavigation();
      }, { passive: true });
    });

    /* Desktop drag browsing — matches Best Sellers behaviour.
       Use mouse events so image links, CSS scroll snapping and pointer captures
       do not swallow a drag. The page's vertical wheel remains untouched. */
    let dragState = null;
    let blockClickUntil = 0;

    function findDragScroller(target) {
      const palette = target.closest('[data-swatches]');
      if (palette && hasOverflow(palette)) return palette;
      const view = target.closest('[data-viewport]');
      if (!view || !hasOverflow(view)) return null;
      if (root.dataset.mouseDrag !== 'true' || mobileQuery.matches) return null;
      if (target.closest('button, select, input, textarea, [data-add-to-cart]')) return null;
      return view;
    }

    root.addEventListener('mousedown', event => {
      if (event.button !== 0 || mobileQuery.matches) return;
      if (!(event.target instanceof Element)) return;
      const scroller = findDragScroller(event.target);
      if (!scroller) return;
      dragState = {
        element: scroller,
        x: event.clientX,
        y: event.clientY,
        startScroll: scroller.scrollLeft,
        moved: false
      };
    });

    document.addEventListener('mousemove', event => {
      if (!dragState) return;
      if (!(event.buttons & 1)) { endMouseDrag(); return; }
      const deltaX = event.clientX - dragState.x;
      const deltaY = event.clientY - dragState.y;
      if (!dragState.moved) {
        if (Math.abs(deltaX) < 6) return;
        // Do not hijack a primarily vertical gesture.
        if (Math.abs(deltaY) > Math.abs(deltaX) * 1.5) return;
        dragState.moved = true;
        dragState.element.classList.add('mh-explore__is-dragging');
        document.documentElement.classList.add('mh-explore--mouse-dragging');
      }
      event.preventDefault();
      dragState.element.scrollLeft = dragState.startScroll - deltaX;
    });

    function endMouseDrag() {
      if (!dragState) return;
      if (dragState.moved) blockClickUntil = Date.now() + 450;
      dragState.element.classList.remove('mh-explore__is-dragging');
      document.documentElement.classList.remove('mh-explore--mouse-dragging');
      dragState = null;
      requestAnimationFrame(toggleCarouselNavigation);
    }
    document.addEventListener('mouseup', endMouseDrag);
    window.addEventListener('blur', endMouseDrag);

    // Product photos should drag the carousel, not start native image ghost-dragging.
    root.addEventListener('dragstart', event => {
      if (!(event.target instanceof Element)) return;
      if (mobileQuery.matches) return;
      if (root.dataset.mouseDrag !== 'true') return;
      if (event.target.closest('[data-viewport] img, [data-viewport] a')) {
        event.preventDefault();
      }
    });

    // Ignore accidental product navigation or colour selection after a true drag.
    root.addEventListener('click', event => {
      if (Date.now() > blockClickUntil || !(event.target instanceof Element)) return;
      if (!event.target.closest('[data-viewport]')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      blockClickUntil = 0;
    }, true);

    function productData(card) {
      if (card._mheProduct) return card._mheProduct;
      let variants = [], names = [];
      try { variants = JSON.parse(card.querySelector('[data-variants]').textContent || '[]'); } catch (_) {}
      try { names = JSON.parse(card.querySelector('[data-option-names]').textContent || '[]'); } catch (_) {}
      card._mheProduct = { variants, names, colourIndex: Number(card.dataset.colourIndex), selectedColour: null };
      const selected = card.querySelector('[data-swatch].is-selected');
      if (selected) card._mheProduct.selectedColour = selected.dataset.swatch;
      return card._mheProduct;
    }

    function variantForColour(card) {
      const product = productData(card);
      const matching = product.variants.filter(variant => {
        return product.colourIndex < 0 || !product.selectedColour || variant.options[product.colourIndex] === product.selectedColour;
      });
      return matching.find(variant => variant.available) || matching[0] || product.variants[0] || null;
    }

    function applyPrice(card, variant) {
      if (!variant) return;
      const price = card.querySelector('[data-price]');
      const compare = card.querySelector('[data-compare]');
      if (price) price.textContent = money(variant.price);
      if (compare) {
        if (variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price)) {
          compare.textContent = money(variant.compare_at_price);
          compare.hidden = false;
        } else {
          compare.textContent = '';
          compare.hidden = true;
        }
      }
    }

    const mhImageCache = new Map();
    const mhImageRequests = new WeakMap();
    const mhOriginalImage = new WeakMap();
    function mhPrepareImage(url) {
      if (!url) return Promise.resolve(false);
      if (mhImageCache.has(url)) return mhImageCache.get(url);
      if (mhImageCache.size >= 24) mhImageCache.delete(mhImageCache.keys().next().value);
      const promise = new Promise(resolve => {
        const image = new Image();
        image.decoding = 'async';
        image.onload = () => {
          (image.decode ? image.decode().catch(() => {}) : Promise.resolve()).then(() => resolve(true));
        };
        image.onerror = () => { mhImageCache.delete(url); resolve(false); };
        image.src = url;
      });
      mhImageCache.set(url, promise);
      return promise;
    }
    root.querySelectorAll('[data-swatch]').forEach(button => {
      const card = button.closest('[data-product-card]');
      if (!card) return;
      const imageSource = button.dataset.image;
      if (imageSource) {
        let previewTimer;
        button.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse' || event.pointerType === 'pen')
            previewTimer = setTimeout(() => mhPrepareImage(imageSource), 140);
        });
        button.addEventListener('pointerleave', () => clearTimeout(previewTimer));
        button.addEventListener('pointerdown', () => {
          clearTimeout(previewTimer);
          mhPrepareImage(imageSource);
        }, {passive:true});
        button.addEventListener('focus', () => mhPrepareImage(imageSource));
      }
      button.addEventListener('click', () => {
        const product = productData(card);
        product.selectedColour = button.dataset.swatch;
        card.querySelectorAll('[data-swatch]').forEach(swatch => {
          const selected = swatch === button;
          swatch.classList.toggle('is-selected', selected);
          swatch.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        const priceVariant = variantForColour(card);
        applyPrice(card, priceVariant);
        const image = card.querySelector('.mh-explore__product-image');
        if (image && imageSource) {
          if (!mhOriginalImage.has(image)) mhOriginalImage.set(image, {
            src: image.getAttribute('src') || '',
            srcset: image.getAttribute('srcset'),
            sizes: image.getAttribute('sizes')
          });
          const sequence = (mhImageRequests.get(card) || 0) + 1;
          mhImageRequests.set(card, sequence);
          const original = mhOriginalImage.get(image);
          if (imageSource === original.src) {
            image.src = original.src;
            if (original.srcset) image.setAttribute('srcset', original.srcset);
            if (original.sizes) image.setAttribute('sizes', original.sizes);
          } else {
            mhPrepareImage(imageSource).then(ready => {
              if (!ready || mhImageRequests.get(card) !== sequence || !image.isConnected) return;
              image.removeAttribute('srcset');
              image.removeAttribute('sizes');
              image.loading = 'eager';
              image.src = imageSource;
              image.alt = button.dataset.imageAlt || card.dataset.productTitle || '';
            });
          }
        }
      });
    });

    function syncCartIcons() {
      root.querySelectorAll('[data-product-card]').forEach(card => {
        const inCart = cartIds.has(String(card.dataset.productId));
        const button = card.querySelector('[data-add-to-cart]');
        if (button) button.classList.toggle('is-in-cart', inCart);
      });
    }

    async function refreshCart() {
      try {
        const response = await fetch(basePath + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
        if (!response.ok) return;
        const cart = await response.json();
        cartIds = new Set((cart.items || []).map(item => String(item.product_id)));
        syncCartIcons();
        const count = root.ownerDocument.querySelector('[data-cart-count]');
        if (count) count.textContent = String(cart.item_count || 0);
      } catch (_) { /* Stay functional if cart fetch is unavailable */ }
    }

    function scheduleCartRefresh() {
      clearTimeout(cartDebounce);
      cartDebounce = setTimeout(refreshCart, 380);
    }

    async function addVariant(variantId, button) {
      if (!variantId) { showToast('Please choose an available option.'); return; }
      if (button) button.disabled = true;
      try {
        const response = await fetch(basePath + 'cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: Number(variantId), quantity: 1 })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'Could not add this item.');
        if (dialog && dialog.open) dialog.close();
        showToast('Added to bag');
        await refreshCart();
        document.dispatchEvent(new CustomEvent('mh-explore:cart-added', { detail: { item: result } }));
        /* Impulse versions differ: announce change without forcing the cart drawer open. */
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { source: 'mh-explore' } }));
      } catch (error) {
        if (dialog && dialog.open && dialogError) dialogError.textContent = error.message || 'Could not add this item.';
        else showToast(error.message || 'Could not add this item.');
      } finally {
        if (button) button.disabled = false;
      }
    }

    function uniqueValues(variants, index) {
      return Array.from(new Set(variants.map(v => v.options[index]).filter(Boolean)));
    }

    function requiresPicker(product) {
      return product.names.some((_, index) => index !== product.colourIndex && uniqueValues(product.variants, index).length > 1);
    }

    function openOptions(card) {
      const product = productData(card);
      if (!dialog || !dialogFields || !confirmAdd) return;
      modalCard = card;
      dialogTitle.textContent = card.dataset.productTitle || 'Choose options';
      dialogFields.replaceChildren();
      dialogError.textContent = '';
      product.names.forEach((name, index) => {
        const label = document.createElement('label');
        label.className = 'mh-explore__variant-label';
        const caption = document.createElement('span');
        caption.textContent = name;
        const select = document.createElement('select');
        select.dataset.optionIndex = String(index);
        const choose = document.createElement('option');
        choose.value = '';
        choose.textContent = 'Choose ' + name;
        select.appendChild(choose);
        uniqueValues(product.variants, index).forEach(value => {
          const option = document.createElement('option');
          option.value = value;
          option.textContent = value;
          select.appendChild(option);
        });
        if (index === product.colourIndex && product.selectedColour) select.value = product.selectedColour;
        else if (uniqueValues(product.variants, index).length === 1) select.value = uniqueValues(product.variants, index)[0];
        label.appendChild(caption);
        label.appendChild(select);
        dialogFields.appendChild(label);
      });
      dialog.showModal();
      const unset = dialogFields.querySelector('select:not([value])');
      if (unset) unset.focus();
    }

    root.querySelectorAll('[data-add-to-cart]').forEach(button => {
      button.addEventListener('click', () => {
        const card = button.closest('[data-product-card]');
        if (!card || card.dataset.available !== 'true') return;
        const product = productData(card);
        if (requiresPicker(product)) openOptions(card);
        else {
          const variant = variantForColour(card);
          if (variant && variant.available) addVariant(variant.id, button);
          else showToast('This colour is currently sold out.');
        }
      });
    });

    if (dialog) {
      const close = dialog.querySelector('[data-close-dialog]');
      if (close) close.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      if (confirmAdd) confirmAdd.addEventListener('click', () => {
        if (!modalCard) return;
        const product = productData(modalCard);
        const selections = Array.from(dialogFields.querySelectorAll('select')).map(select => select.value);
        if (selections.some(value => !value)) {
          dialogError.textContent = 'Please select an option for each field.';
          return;
        }
        const variant = product.variants.find(v => v.available && v.options.every((value, index) => value === selections[index]));
        if (!variant) { dialogError.textContent = 'This combination is currently unavailable.'; return; }
        dialogError.textContent = '';
        applyPrice(modalCard, variant);
        addVariant(variant.id, confirmAdd);
      });
    }

    /* Vertical wheel movement scrolls the PAGE. Hold Shift to use the wheel horizontally. */
    root.addEventListener('wheel', event => {
      if (!event.shiftKey) return;
      const strip = event.target.closest('[data-swatches]');
      const target = strip || event.target.closest('[data-viewport]');
      if (!target || !hasOverflow(target)) return;
      const amount = Math.abs(event.deltaX) > Math.abs(event.deltaY) ? event.deltaX : event.deltaY;
      target.scrollLeft += amount;
      event.preventDefault();
    }, { passive: false });

    /* Native vertical scrolling is never intercepted. Horizontal trackpad movement,
       mouse dragging and carousel arrows all continue to work. */
    window.addEventListener('resize', () => {
      requestAnimationFrame(() => { toggleCarouselNavigation(); updateTabArrows(); });
    });
    document.addEventListener('visibilitychange', () => { if (!document.hidden) scheduleCartRefresh(); });
    window.addEventListener('focus', scheduleCartRefresh);
    window.addEventListener('pageshow', scheduleCartRefresh);
    ['cart:updated', 'cart:change', 'theme:cart:change'].forEach(name => {
      document.addEventListener(name, scheduleCartRefresh);
    });
    document.addEventListener('click', event => {
      if (event.target.closest('[data-cart-remove], .cart__remove, .js-qty__adjust, [name="update"], [href*="/cart/change"]')) {
        setTimeout(refreshCart, 650);
        setTimeout(refreshCart, 1700);
      }
    });

    selectCategory(activeId, false);
    updateTabArrows();
    if (root.querySelector('[data-add-to-cart]')) refreshCart();
    setTimeout(toggleCarouselNavigation, 300);
  }

  function initAll(context) {
    const target = context || document;
    if (target.matches && target.matches('[data-mh-explore]')) initSection(target);
    target.querySelectorAll('[data-mh-explore]').forEach(initSection);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(document));
  else initAll(document);
  document.addEventListener('shopify:section:load', event => initAll(event.target));
  document.addEventListener('shopify:block:select', event => {
    const tab = event.target.querySelector && event.target.querySelector('[data-tab]');
    if (tab) tab.click();
  });
})();
